<template>
  <div>
    <span>
      <strong style="font-size:20px">评级统计</strong>
    </span>
    <span>
      <table align="center" border="1" style="width: 500px;font-size:20px;">
        <tr align="center" height="40px">
          <th>等级</th>
          <th>A</th>
          <th>B</th>
          <th>C</th>
          <th>D</th>
        </tr>
        <tr align="center" height="40px">
          <th>分值范围</th>
          <th>100~95</th>
          <th>94~81</th>
          <th>80~70</th>
          <th>70以下</th>
        </tr>
      </table>
    </span>
    <template>
      <div ref="myEchart1" style="width:500px;height:400px;float:left"></div>
      <div ref="myEchart4" style="width:1050px;height:400px;float:left"></div>
    </template>
  </div>
</template>

<script>
import echarts from "echarts";

import { statistics_score } from "@/api";

export default {
  data() {
    return {
      dataList: [],
      data1:[],
      data2:[]
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let self = this;
      statistics_score().then((res) => {
        console.log(res);
        for (var a in res) {
          self.dataList.push({
            value: res[a],
            name: a
          });
          this.data1.push(a);
          this.data2.push(res[a]);
        }

        self.initChart1();
        self.initChart4();
      }).finally((res) => { });
    },
    // 图表初始化数据
    initChart1() {
      let myChart = echarts.init(this.$refs.myEchart1);
      // let dataList = [
      //   { value: 4, name: "信息分公司" },
      //   { value: 11, name: "配电分公司" },
      //   { value: 68, name: "汉阳分公司" },
      //   { value: 78, name: "汉口分公司" },
      //   { value: 152, name: "武昌分公司" },
      //   { value: 8, name: "武汉华源电力有限公司" },
      //   { value: 3, name: "基础设施工程分公司" },
      // ];
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} <br/> ({d}%)",
        },
        series: [
          {
            name: "等级",
            type: "pie",
            radius: "80%",
            center: ["52%", "53%"],
            avoidLabelOverlap: false,
            data: this.dataList,
            itemStyle: {
              emphasis: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.3)",
              },
            },
          },
        ],
      });
    },


    initChart4() {
      let myChart = echarts.init(this.$refs.myEchart4);
      myChart.setOption({
        color: ["#f44"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.data1,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "等级",
            type: "bar",
            barWidth: "60%",
            data: this.data2,
          },
        ],
      });
    },


  },
  beforeDestroy() { },
};
</script>

<style scoped>

</style>
